import {FC} from 'react'
import {PrintFlowOutcome} from '../printFlow/outcomeModel'

type Props = {outcome: PrintFlowOutcome}

const CodeRow: FC<{
  label: string
  printableReady: boolean
  detail: string
}> = ({label, printableReady, detail}) => (
  <div className='mb-4'>
    <div className='d-flex align-items-center justify-content-between gap-3 mb-1'>
      <span className='fw-bold text-gray-800 fs-6'>{label}</span>
      <span className={`badge ${printableReady ? 'badge-light-success' : 'badge-light'}`}>
        {printableReady ? 'Printable ready' : 'Printable pending'}
      </span>
    </div>
    <div className='text-gray-700 fs-6'>{detail}</div>
  </div>
)

export const CodeGroups: FC<Props> = ({outcome}) => (
  <div className='card card-flush border border-gray-200 mb-6'>
    <div className='card-header border-0 pt-5 pb-0'>
      <div className='card-title flex-column align-items-start'>
        <span className='fw-bold text-gray-800'>Codes</span>
        <span className='text-muted fs-7 fw-semibold mt-1'>
          Consumer delivery vs staff printing routes
        </span>
      </div>
    </div>
    <div className='card-body pt-5'>
      <div className='mb-5'>
        <div className='fw-bold text-gray-800 fs-7 mb-3'>Consumer delivery codes</div>
        {outcome.codes.consumer.length === 0 ? (
          <div className='text-gray-700 fs-6'>None</div>
        ) : (
          outcome.codes.consumer.map((code) => (
            <CodeRow
              key={code.codeId}
              label={code.code || code.codeId}
              printableReady={code.printableReady}
              detail={
                code.prefetchDeviceCount > 0
                  ? `Prefetched to ${code.prefetchDeviceCount} device${
                      code.prefetchDeviceCount === 1 ? '' : 's'
                    }`
                  : 'No prefetch targets yet'
              }
            />
          ))
        )}
      </div>

      <div className='separator separator-dashed mb-5'></div>

      <div>
        <div className='fw-bold text-gray-800 fs-7 mb-3'>Staff printing code</div>
        {outcome.codes.staff.length === 0 ? (
          <div className='text-gray-700 fs-6'>None</div>
        ) : (
          outcome.codes.staff.map((code) => (
            <CodeRow
              key={code.codeId}
              label={code.code || code.codeId}
              printableReady={code.printableReady}
              detail={
                code.assignedPrinter
                  ? `Assigned printer: ${code.assignedPrinter}`
                  : 'No assigned printer stamped'
              }
            />
          ))
        )}
      </div>
    </div>
  </div>
)
